import { IntlShape } from 'react-intl';
import { z } from 'zod';
import { declaredColumnTypes } from '../types';
import { datasetNamePattern } from './generateDatasetName';

export const createFormSchema = (intl: IntlShape) => {
  const required = intl.formatMessage({
    id: 'features.datasets.settings.error.required',
  });

  return z.object({
    name: z
      .string()
      .min(1, { message: required })
      .regex(datasetNamePattern, {
        message: intl.formatMessage({
          id: 'features.datasets.settings.form.idSection.id.error.invalid',
        }),
      }),
    metadata: z
      .object({
        name: z.string().min(1, { message: required }),
        description: z.string(),
      })
      .partial()
      .default({}),
    encoding: z.string(),
    columns: z
      .array(
        z.object({
          label: z.string().min(1, { message: required }),
          attributeName: z
            .string()
            .min(1, { message: required })
            .regex(datasetNamePattern, {
              message: intl.formatMessage({
                id: 'features.datasets.create.columns.attributeName.error.invalid',
              }),
            }),
          type: z.enum(declaredColumnTypes),
        })
      )
      .superRefine((columns, ctx) => {
        const seen = new Set<string>();
        columns.forEach((column, index) => {
          // An empty attribute is already reported as required.
          if (column.attributeName !== '' && seen.has(column.attributeName)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [index, 'attributeName'],
              message: intl.formatMessage({
                id: 'features.datasets.create.columns.attributeName.error.duplicate',
              }),
            });
          }
          seen.add(column.attributeName);
        });
      }),
  });
};

export type CreateForm = z.input<ReturnType<typeof createFormSchema>>;
